/**
 * components/filters/SelectFilter.js — Ерөнхий сонголтын шүүлт.
 * Төлөв / түвшин / төрөл гэх мэт шүүлтэд дахин ашиглагдана.
 *
 * SearchInput-тэй ижил шалтгаанаар native `<select>`-ээс antd `Select` рүү
 * шилжив — апп-ийн бусад хэсэгтэй нэг харагдацтай байх ёстой.
 *
 * Props:
 *   value, onChange(value)     — "" = бүгд (шүүлтгүй)
 *   options: [{ value, label }]
 *   placeholder                — сонгоогүй үеийн текст
 *   style, size
 *   width                      — өгөгдмөл 100%; FilterBar дотор flex-ээр багасна
 *
 * ⚠ antd Select нь юу ч сонгоогүй үед `undefined` буцаадаг. Дуудагч талууд
 *   "" (хоосон мөр)-ийг «шүүлтгүй» гэж үздэг тул энд хөрвүүлж өгнө.
 */
import React from "react";
import { Select } from "antd";

export default function SelectFilter({
  value,
  onChange,
  options = [],
  placeholder = "Бүгд",
  style,
  // undefined = ConfigProvider-оос өвлөнө (SearchInput-тэй ижил зарчим)
  size,
  width,
}) {
  return (
    <Select
      value={value || undefined}
      onChange={(v) => onChange?.(v ?? "")}
      placeholder={placeholder}
      size={size}
      allowClear
      options={options}
      style={{ flex: "0 1 auto", minWidth: 140, width: width || undefined, ...style }}
    />
  );
}
